import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var selectionToolbarPluginKey = new PluginKey('selectionToolbarPluginKey');